<script lang="ts">
  import HelpOverlay from "../help/Overlay.svelte";
  import HelpButton from "../help/Button.svelte";
  import KeyboardShortcuts from "../KeyboardShortcuts.svelte";
  import Image from "../Image.svelte";
  import ImageNav from "../ImageNav.svelte";
  import { setShortcode } from "../stores";
  import { navigate, Link } from "svelte-navigator";

  export let shortcode: null | string = null;
  $: setShortcode(shortcode);
</script>

<KeyboardShortcuts />

<header>
  <h3>
    <Link to="/" title="home">home</Link>
    <span class="separator">></span>
    {#if shortcode}
      <Link to="/art" title="art">art</Link>
      <span class="separator">></span>
      {shortcode}
    {:else}
      art
    {/if}
  </h3>

  {#if shortcode}
    <HelpButton />
  {/if}
</header>

{#if shortcode}
  <HelpOverlay />
{/if}

<div id="art">
  <ImageNav />

  {#if shortcode}
    <Image {shortcode} />
  {/if}
</div>

<style>
  #art {
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
  }

  header {
    display: flex;
    justify-content: space-between;
    align-content: baseline;
  }
  h3 {
    display: flex;
  }
  span.separator {
    margin: 0 0.25rem;
  }
</style>
